<script src="../utils/faker.js"></script>
<template>
  <div>
    <div class="flex">
      <!-- BEGIN: Side Menu -->
      <nav class="side-nav">
        <!-- BEGIN: Logo -->
        <router-link
          :to="{ path: '/workBench/workbench' }"
          tag="a"
          class="intro-x flex items-center pl-5 pt-4"
        >
          <img
            alt="Midone Tailwind HTML Admin Template"
            class="w-6"
            src="@/assets/images/logo.svg"
          />
          <span class="hidden xl:block text-white text-lg ml-3">
            <span class="font-medium">楼管家</span>
          </span>
        </router-link>
        <!-- END: Logo -->
        <div class="side-nav__devider my-6"></div>
        <ul>
          <!-- BEGIN: First Child -->
          <template v-for="(menu, index) in slide" v-if="!menu.meta.hidden && menu.meta.show">
            <li :key="index">
              <SideMenuTooltip
                tag="a"
                :content="menu.meta.title"
                href="javascript:;"
                class="side-menu"
                :class="{
                  'side-menu--active': activeMenu==menu.path,
                  'side-menu--open': activeMenu==menu.path
                }"
                @click.native="linkTo(menu)"
              >
                <div class="side-menu__icon">
                  <component :is="icons[index]" />
                </div>
                <div class="side-menu__title">
                  {{ menu.meta.title }}
                  <ChevronDownIcon
                    v-if="menu.children&&menu.children.length"
                    class="side-menu__sub-icon"
                    :class="{ 'transform rotate-180': activeSlide.includes(menu.path) }"
                  />
                </div>
              </SideMenuTooltip>
              <!-- BEGIN: Second Child -->
              <transition @enter="enter" @leave="leave">
                <ul v-if="menu.children&&menu.children.length && activeMenu==menu.path">
                  <li
                    v-for="(subMenu, subMenuKey) in menu.children"
                    :key="menu.path+subMenu.path"
                    v-if='!subMenu.meta.hidden&&subMenu.meta.show'>
                    <SideMenuTooltip
                      tag="a"
                      :content="subMenu.meta.title"
                      href="javascript:;"
                      class="side-menu"
                      :class="{ 'side-menu--active': activeSlide.split('/')[2]==subMenu.path }"
                      @click.native="linkTo(subMenu,menu)"
                    >
                      <div class="side-menu__icon">
                        <ActivityIcon />
                      </div>
                      <div class="side-menu__title">
                        {{ subMenu.meta.title }}
                      </div>
                    </SideMenuTooltip>
                  </li>
                </ul>
              </transition>
              <!-- END: Second Child -->
            </li>
          </template>
          <!-- END: First Child -->
        </ul>
      </nav>
      <!-- END: Side Menu -->
      <!-- BEGIN: Content -->
      <div class="content">
        <TopBar />
        <router-view />
      </div>
      <!-- END: Content -->
    </div>
  </div>
</template>

<script>
import Velocity from "velocity-animate";
import TopBar from "@/components/TopBar";
import SideMenuTooltip from "@/components/SideMenuTooltip";
import {getCookie} from "../assets/js/tools";
import {mapState} from 'vuex'
export default {
  components: {
    SideMenuTooltip,
    TopBar
  },
  data() {
    return {
      activeMenu:"",
      icons:['HomeIcon','BoxIcon','CreditCardIcon','FileTextIcon','TrelloIcon','LayoutIcon','HardDriveIcon']
    };
  },
  mounted() {
    $("body")
      .removeClass("login")
      .addClass("app");
  },
  methods: {
    nestedMenu(menu) {
      menu.forEach((item, key) => {
        if (typeof item !== "string") {
          menu[key].active =
            (item.pageName == this.$route.name ||
              (this.$h.isset(item.subMenu) &&
                this.findActiveMenu(item.subMenu))) &&
            !item.ignore;
        }

        if (this.$h.isset(item.subMenu)) {
          menu[key].activeDropdown = this.findActiveMenu(item.subMenu);
          menu[key] = {
            ...item,
            ...this.nestedMenu(item.subMenu)
          };
        }
      });

      return menu;
    },
    findActiveMenu(subMenu) {
      let match = false;
      subMenu.forEach(item => {
        if (item.pageName == this.$route.name && !item.ignore) {
          match = true;
        } else if (!match && this.$h.isset(item.subMenu)) {
          match = this.findActiveMenu(item.subMenu);
        }
      });
      return match;
    },
    linkTo(menu,parentMenu) {
      if(parentMenu){
        this.$router.push(`/${parentMenu.path}/${menu.path}`)
      }else{
        this.activeMenu=menu.path
      }
    },
    enter(el, done) {
      Velocity(
        el,
        "slideDown",
        {
          duration: 300
        },
        {
          complete: done
        }
      );
    },
    leave(el, done) {
      Velocity(
        el,
        "slideUp",
        {
          duration: 300
        },
        {
          complete: done
        }
      );
    }
  },
  created() {
    this.$store.dispatch('getAccountProfile')
    this.activeMenu=this.$route.path.split('/')[1]
  },
  beforeRouteEnter(to, form, next) {
    if (!getCookie('louguanjia_app_ticket')) {
      next('/login')
    } else {
      if(to.meta.show){
        next()
      }else{
        // next('/404')
      }
    }
  },
  watch:{
    $route:function () {
      this.activeMenu=this.$route.path.split('/')[1]
    }
  },
  computed: {
    ...mapState({
      slide:state=>state.user.user.permission.frontMenu,
    }),
    activeSlide: function () {
      return this.$route.query.activeSlide || this.$route.meta.activeSlide || this.$route.path
    }
  },
};
</script>
